export const RejectionReason = {
    CloseButton: Symbol('close button'),
    Backdrop: Symbol('backdrop'),
    EscapeKey: Symbol('escape key'),
    CancelButton: Symbol('cancel'),
    BackButton: Symbol('back button'),
}
